import { __decorate } from "tslib";
import { ZoneId } from '@js-joda/core';
import { ValidatorConstraint } from 'class-validator';
import { SUPPORTED_TIMEZONES } from '../Timezone';
/**
 * Validates whether a ZoneId is a supported time zone.
 * Also validates whether a string is a valid timezone value, as ftr-web doesn't import @js-joda/timezone
 * @see https://github.com/typestack/class-validator#custom-validation-classes
 */
let SupportedTimezone = class SupportedTimezone {
    validate(zone) {
        return !!SUPPORTED_TIMEZONES.find(tz => {
            return tz.jodaTimezone === (zone instanceof ZoneId ? zone.toString() : zone);
        });
    }
    defaultMessage() {
        return '$value is not a supported timezone.';
    }
};
SupportedTimezone = __decorate([
    ValidatorConstraint({ name: 'supportedTimezone', async: false })
], SupportedTimezone);
export { SupportedTimezone };
